.icon {
	@apply yst-text-slate-600;
}
